import {EVENT_PREFIX} from '../../../helpers';

export default (
  {
    field,
    instanceKey
  }) => (Object.assign({
  type: `${EVENT_PREFIX}_UNTOUCH_FIELD`
}, {field, instanceKey}));
